import FooterViewModelT from '@/ViewModels/Views/FooterViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
export default class FooterViewFactory extends ViewFactory {
    public viewModel: any;
    public view: any;
    private FooterViewModel: any;
    private FooterView: any;
    constructor(params: any) {
        super(params);
        this.FooterViewModel = ComponentManager.getViewModel<typeof FooterViewModelT>('FooterViewModel');
        this.FooterView = ComponentManager.getView('FooterView');
    }
    public getRegion(): string {
        return 'Footer';
    }
    public getView(): any {
        if (this.viewModel == null) {
            this.viewModel = new this.FooterViewModel({ viewFactory: this });
        }
        if (this.view == null) {
            this.view = new this.FooterView(this.viewModel, this.createRootElement('Footer'));
        }
        let tuple = this.view.getTuple();
        return tuple.view;
    }
}

ComponentManager.setFactory('Footer', FooterViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');